import { Component, Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { HelpModel } from '../../../shared/help/help.model';

@Component({
    selector: 'convfact-adminhelp-form',
    templateUrl: './help-form.component.html',
    styleUrls: ['./help.component.css'],
    standalone: false
})

export class AdminHelpFormComponent {
  @Input() help: HelpModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;

  constructor() { }

  save(help) {
    help.cultureId = "1"; //Asignamos español por defecto
    this.onSave.emit(help)
  }

  changeToggle(element, other) {
    this.help[other] = (this.help[element]);
  }

}
